import { useEffect, useState } from "react";
// import { useRecoilState } from "recoil";
// import { memberState } from "../../../state/atoms";
import "../PrintCheckoutPage";
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Alert, Button, Checkbox, Space, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import OrdersApi from "../../../api/OrdersApi";
// import PrintApi from "../../../api/PrintApi";
import "../PrintCheckoutPage.scss";
import PrintApi from "../../../api/PrintApi";

const { Paragraph } = Typography;

export function StripeForm({ order, setView, loading, setLoading, setCartCount, member }: any) {
  // const [loading, setLoading] = useState(false);
  // const [member] = useRecoilState(memberState);

  const stripe = useStripe();
  const elements = useElements();
  // const [clientSecret, setClientSecret] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isDefaultPaymentMethod, setIsDefaultPaymentMethod] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecretFromUrl = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecretFromUrl) {
      return;
    }

    setLoading(true);

    stripe.retrievePaymentIntent(clientSecretFromUrl).then(({ paymentIntent }) => {
      switch (paymentIntent!.status) {
        case "succeeded":
          order.paymentIntent = JSON.stringify(paymentIntent)
          submitOrder();
          break;
        case "processing":
        case "requires_payment_method":
        default:
          setLoading(false);
          break;
      }
    });
  });

  function beforeUnloadFunc(e: any) {
    e.preventDefault();
    e.returnValue = "";
  }

  const handleSubmit = async (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    window.addEventListener("beforeunload", beforeUnloadFunc);

    if (!stripe || !elements) return;

    setErrorMessage('');
    setLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: 'http://localhost:3000/print/checkout/payment',
      },
    });

    if (error) {
      setErrorMessage(error.message!);
      setLoading(false);
      window.removeEventListener("beforeunload", beforeUnloadFunc);
    } else {
      console.log(paymentIntent);
      order.paymentIntent = JSON.stringify(paymentIntent);

      if (isDefaultPaymentMethod && paymentIntent.payment_method) {
        PrintApi.setDefaultPaymentMethod(member.email, member.internalId, paymentIntent.payment_method.toString()).then(resp => {
          submitOrder();
        }).catch((err) => {
          console.log(err);
          submitOrder();
        });
      } else {
        submitOrder();
      }
    }
  };

  function submitOrder() {
    setLoading(true);

    if (order.coupon) {
      PrintApi.saveUsedCoupon(order.coupon, member.internalId)
    }

    OrdersApi.submitOrder(order)
      .then((resp) => {
        console.log(resp);
        setLoading(false);
        setCartCount(0)
        setView("success");
        window.removeEventListener("beforeunload", beforeUnloadFunc);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        window.removeEventListener("beforeunload", beforeUnloadFunc);
      });
  }

  function onReturnClick() {
    setView("shipping");
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PaymentElement className="stripe-payment-element" />

        <Paragraph>
          {errorMessage && <Alert
            message={errorMessage}
            description="Please check your payment data."
            type="error"
            showIcon
          />}
        </Paragraph>

        <Checkbox onChange={() => { setIsDefaultPaymentMethod(!isDefaultPaymentMethod) }} style={{ marginBottom: 20, fontWeight: "normal" }}>
          Save as the default payment method
        </Checkbox>

        <Space className={"footer-btns"} direction="vertical" style={{ width: '100%' }}>
          <Button htmlType="submit" type="primary" size="large" block disabled={!stripe} loading={loading}>
            Submit Order
          </Button>

          <Button className={"return-to-previous"} type="text" block onClick={onReturnClick}>
            &lt; Return to Shipping
          </Button>
        </Space>
      </form>
      <div className={`processing-overlay ${loading ? 'processing' : ''}`}>
        <LoadingOutlined />
        <p>Processing...</p>
      </div>
    </>
  );
}
